export default "__VITE_ASSET__QyLWfoAa__"